import a from './assets/slack/a.png';
import b from './assets/slack/b.png';
import c from './assets/slack/c.png';
import d from './assets/slack/d.png';
import e from './assets/slack/e.png';
import f from './assets/slack/f.png';
import g from './assets/slack/g.png';
import h from './assets/slack/h.png';
import i from './assets/slack/i.png';
import j from './assets/slack/j.png';
import k from './assets/slack/k.png';
import l from './assets/slack/l.png';
import m from './assets/slack/m.png';
import n from './assets/slack/n.png';
import o from './assets/slack/o.png';
import p from './assets/slack/p.png';
import q from './assets/slack/q.png';
import r from './assets/slack/r.png';
import s from './assets/slack/s.png';
import t from './assets/slack/t.png';
import u from './assets/slack/u.png';
import v from './assets/slack/v.png';
import w from './assets/slack/w.png';
import x from './assets/slack/x.png';
import y from './assets/slack/y.png';
import z from './assets/slack/z.png';
import exclamation from './assets/slack/exclamation.png';
import pound from './assets/slack/pound.png';
import at from './assets/slack/at.png';
import question from './assets/slack/question.png';
import React from 'react';
// Yellow assets
import ya from './assets/slack-yellow/alphabet-yellow-a.png';
import yb from './assets/slack-yellow/alphabet-yellow-b.png';
import yc from './assets/slack-yellow/alphabet-yellow-c.png';
import yd from './assets/slack-yellow/alphabet-yellow-d.png';
import ye from './assets/slack-yellow/alphabet-yellow-e.png';
import yf from './assets/slack-yellow/alphabet-yellow-f.png';
import yg from './assets/slack-yellow/alphabet-yellow-g.png';
import yh from './assets/slack-yellow/alphabet-yellow-h.png';
import yi from './assets/slack-yellow/alphabet-yellow-i.png';
import yj from './assets/slack-yellow/alphabet-yellow-j.png';
import yk from './assets/slack-yellow/alphabet-yellow-k.png';
import yl from './assets/slack-yellow/alphabet-yellow-l.png';
import ym from './assets/slack-yellow/alphabet-yellow-m.png';
import yn from './assets/slack-yellow/alphabet-yellow-n.png';
import yo from './assets/slack-yellow/alphabet-yellow-o.png';
import yp from './assets/slack-yellow/alphabet-yellow-p.png';
import yq from './assets/slack-yellow/alphabet-yellow-q.png';
import yr from './assets/slack-yellow/alphabet-yellow-r.png';
import ys from './assets/slack-yellow/alphabet-yellow-s.png';
import yt from './assets/slack-yellow/alphabet-yellow-t.png';
import yu from './assets/slack-yellow/alphabet-yellow-u.png';
import yv from './assets/slack-yellow/alphabet-yellow-v.png';
import yw from './assets/slack-yellow/alphabet-yellow-w.png';
import yx from './assets/slack-yellow/alphabet-yellow-x.png';
import yy from './assets/slack-yellow/alphabet-yellow-y.png';
import yz from './assets/slack-yellow/alphabet-yellow-z.png';
import yexclamation from './assets/slack-yellow/alphabet-yellow-exclamation.png';
import yhash from './assets/slack-yellow/alphabet-yellow-hash.png';
import yat from './assets/slack-yellow/alphabet-yellow-at.png';
import yquestion from './assets/slack-yellow/alphabet-yellow-question.png';

export const alphabetWhiteMapping = {
    a: a,
    b: b,
    c: c,
    d: d,
    e: e,
    f: f,
    g: g,
    h: h,
    i: i,
    j: j,
    k: k,
    l: l,
    m: m,
    n: n,
    o: o,
    p: p,
    q: q,
    r: r,
    s: s,
    t: t,
    u: u,
    v: v,
    w: w,
    x: x,
    y: y,
    z: z,
    '!': exclamation,
    '#': pound,
    '@': at,
    '?': question,
};


export const alphabetYellowMapping = {
    a: ya,
    b: yb,
    c: yc,
    d: yd,
    e: ye,
    f: yf,
    g: yg,
    h: yh,
    i: yi,
    j: yj,
    k: yk,
    l: yl,
    m: ym,
    n: yn,
    o: yo,
    p: yp,
    q: yq,
    r: yr,
    s: ys,
    t: yt,
    u: yu,
    v: yv,
    w: yw,
    x: yx,
    y: yy,
    z: yz,
    '!': yexclamation,
    '#': yhash,
    '@': yat,
    '?': yquestion,
};

export function getEmojiCodeSnippet(message, variant = 'white') {
    if (message === null) return <div/>;
    let inputArray = message.split('');

    function getPrefixAt(index) {
        if (variant === 'annoying') {
            return index % 2 === 0 ? 'alphabet-white' : 'alphabet-yellow';
        }
        return variant === 'yellow' ? 'alphabet-yellow' : 'alphabet-white';
    }

    function buildCodeSnippet(c, index) {
        const prefix = getPrefixAt(index);
        switch (c) {
            case '!':
                return `:${prefix}-exclamation:`;
            case '#':
                return `:${prefix}-hash:`;
            case '@':
                return `:${prefix}-at:`;
            case '?':
                return `:${prefix}-question:`;
            default:
                return `:${prefix}-${c}:`;
        }

    }

    let codeString = '';
    return inputArray.map((c, index) => {
        const map = (variant === 'annoying'
            ? (index % 2 === 0 ? alphabetWhiteMapping : alphabetYellowMapping)
            : (variant === 'yellow' ? alphabetYellowMapping : alphabetWhiteMapping));
        if (map.hasOwnProperty(c.toLowerCase())) return codeString + buildCodeSnippet(c.toLowerCase(), index);
        if (c === ' ') return codeString + `\u00A0\u00A0\u00A0`;
        return codeString + c;
    });
}

export function getEmoji(message, variant = 'white', size = 25) {
    let inputArray = message.split('');

    function buildImg(c, index) {
        const map = (variant === 'annoying'
            ? (index % 2 === 0 ? alphabetWhiteMapping : alphabetYellowMapping)
            : (variant === 'yellow' ? alphabetYellowMapping : alphabetWhiteMapping));
        return <img key={offset} src={map[c.toLowerCase()]} alt={c} width={size + 'px'}
                    height={size + 'px'}/>;
    }
    let offset = 0;
    return inputArray.map((c, index) => {
        offset++;
        const map = (variant === 'annoying'
            ? (index % 2 === 0 ? alphabetWhiteMapping : alphabetYellowMapping)
            : (variant === 'yellow' ? alphabetYellowMapping : alphabetWhiteMapping));
        if (map.hasOwnProperty(c.toLowerCase())) return buildImg(c, index);
        if (c === ' ') return <span key={offset} className='d-inline'>{`\u00A0\u00A0\u00A0`}</span>;
        return <span key={offset} className='d-inline'>{c}</span>;
    });
}